import React, { Component } from "react";
import { utcToReport24 } from "../../utils/dateConvert";
import { offsetMapLocation } from "../../utils/map";
import _ from "lodash";
import { here_api_key } from "../../utils/mapapi";
import RealMapBubble from "./realMapBubble";
import "../../styles/maps/map.scss";
import ReactDOM from "react-dom";

class RealMap extends Component {
  constructor(props) {
    super(props);
    this.arr = [];
    this.truckArr = [];
    this.bubbleObj = {};
    this.dataPoints = [];
    this.mapBehaviour = null;
  }

  componentDidMount() {
    // constants
    var platform = new window.H.service.Platform({
      apikey: here_api_key,
    });

    let engineType = window.H.Map.EngineType["HARP"];

    // Obtain the default map types from the platform object
    var maptypes = platform.createDefaultLayers({
      engineType: engineType,
    });

    let defaultLayer = maptypes.vector.normal.map;

    // Instantiate (and display) a map object:
    let map = new window.H.Map(
      document.getElementById("realMapContainer"),
      defaultLayer,
      {
        engineType: engineType,
        center: { lng: 140.4, lat: -37.51 },
        zoom: 14,
      }
    );

    var viewPort = map.getViewPort();
    viewPort.setPadding(50, 300, 50, 300);

    window.map = map;
    window.addEventListener("resize", () => viewPort.resize());

    this.mapBehaviour = new window.H.mapevents.Behavior(
      new window.H.mapevents.MapEvents(map)
    );

    var scrollBlock = document.getElementById("mapScrollBlock");

    var ctrlDown = false;
    var isMouseOverMap = false;
    var mapContainer = document.getElementById("realMapContainer");

    mapContainer.addEventListener("mouseenter", function () {
      isMouseOverMap = true;
    });

    mapContainer.addEventListener("mouseleave", function () {
      isMouseOverMap = false;
    });

    var checkCtrl = (event) => {
      if (event.key !== "Control") return;
      if (event.repeat) return;

      ctrlDown = event.type === "keydown";

      if (ctrlDown) {
        this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
        scrollBlock.classList.add("fade-out");
        scrollBlock.classList.remove("in");
        setTimeout(() => {
          scrollBlock.classList.remove("fade-out");
        }, 300);
      } else if (!this.props.isFullScreen) {
        this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
      }
    };

    // Using global events since we want to capture regardless of where you are on the page
    document.addEventListener("keydown", checkCtrl);
    document.addEventListener("keyup", checkCtrl);

    var scrollTimer = null;

    var self = this;

    // And HERE captures wheel events at the document level so we have to go to the very highest level to undo their mistakes
    window.addEventListener(
      "wheel",
      function (event) {
        if (!isMouseOverMap) return;
        if (ctrlDown) return;
        if (self.props.isFullScreen) return;
        if (scrollTimer) clearTimeout(scrollTimer);

        scrollBlock.classList.remove("fade-out");
        scrollBlock.classList.add("in");
        scrollTimer = setTimeout(() => {
          scrollBlock.classList.add("fade-out");
          setTimeout(() => {
            scrollBlock.classList.remove("in");
            scrollBlock.classList.remove("fade-out");
            scrollTimer = null;
          }, 300);
        }, 2000);
      },
      {
        capture: true,
        passive: true,
      }
    );

    // Disable wheel zoom by default
    this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);

    var ui = window.H.ui.UI.createDefault(map, maptypes);

    window.ui = ui;

    // clustering
    this.setTruckPoints(true);
  }

  componentDidUpdate(prevProps) {
    // Check to see if the list of assets has changed.
    // TODO: Only set true when an actual user interaction has occurred, this is only an approximation of that
    var currentAssetList = _.map(this.props.realTimeData, "assetId");
    var previousAssetList = _.map(prevProps.realTimeData, "assetId");

    var hasDifferentAssets =
      _.xor(previousAssetList, currentAssetList).length > 0;
    var isMapChange = this.props.mapChange != prevProps.mapChange;

    if (!hasDifferentAssets && isMapChange) {
      this.addClusterPoint(JSON.parse(this.props.mapChange));
    } else {
      // If we have a lot of assets, it's faster to redraw the whole table
      if (
        this.props.realTimeData.length >= 50 ||
        this.props.realTimeData.length === 1
      ) {
        if (this.props.realTimeData !== prevProps.realTimeData) {
          this.setTruckPoints(
            hasDifferentAssets || this.props.realTimeData.length === 1
          );
        }
      } else if (hasDifferentAssets) {
        this.setTruckPoints(true);
      }
    }

    if (this.props.singleTruckZoom !== prevProps.singleTruckZoom) {
      this.handleTruckZoom(this.props.singleTruckZoom);
    }

    if (this.props.isFullScreen !== prevProps.isFullScreen) {
      if (this.props.isFullScreen) {
        this.mapBehaviour.enable(window.H.mapevents.Behavior.WHEELZOOM);
      } else {
        this.mapBehaviour.disable(window.H.mapevents.Behavior.WHEELZOOM);
      }
    }
  }

  handleTruckZoom = async (data) => {
    var position = {
      lat: data.lat,
      lng: data.lng,
    };

    window.scrollTo(0, 0); // Scroll to top

    // If we have a method for fetching a bounding box, we're a cluster
    window.map.getViewModel().setLookAtData({
      position: position,
      zoom: 16,
    });

    this.handleOpenBubble(position, data);
  };

  addClusterPoint = (data) => {
    if (data.lastMessage) {
      this.checkUpdateDataPoint(data);
      const optData = {
        assetId: data.lastMessage.assetID,
        created: data.lastMessage.created,
        address: data.lastMessage.location,
        lat: data.lastMessage.gPRMC.latitude,
        lng: data.lastMessage.gPRMC.longitude,
        speed: data.lastMessage.gPRMC.speed,
        odometer: data.lastMessage.odometer,
        name: data.assetName,
        tempA: data.lastMessage.sensorAValue || "",
        tempB: data.lastMessage.sensorBValue || "",
        fridge: this.handleFridge(
          data.lastMessage.iO1,
          data.lastMessage.sensorBValue
        ),
        gprs: data.lastMessage.gprsOnline,
        heading: data.lastMessage.gPRMC.heading,
        parking: data.lastMessage.iO3,
        trip: data.lastMessage.tripCount,
        duress: data.lastDuress || "",
        volt: data.lastMessage.deviceVolts,
        satelite: data.lastMessage.satellites,
        lastUpdated: data.lastMessage.received,
        friendlyName: data.friendlyName,
        lastDuress: data.lastDuress || "",
        lastPowerCut: data.lastPowerCut || "",
        lastStatusChange: data.lastStatusChange || "",
      };
      let lat = data.lastMessage.gPRMC.latitude;
      let lng = data.lastMessage.gPRMC.longitude;

      var dataPoint = new window.H.clustering.DataPoint(
        lat,
        lng,
        null,
        optData
      );
      this.dataPoints.push(dataPoint);

      window.clusteredDataProvider.addDataPoint(dataPoint);
    }
  };

  checkUpdateDataPoint = (data) => {
    var assetIdToMatch = data.lastMessage.assetID;

    this.dataPoints.forEach((point, index) => {
      if (point.data.assetId == assetIdToMatch) {
        this.removeClusterPoint(point);
      }
    });

    _.remove(this.dataPoints, function (point) {
      return point.data.assetId == assetIdToMatch;
    });
  };

  removeClusterPoint = (dataPoint) => {
    window.clusteredDataProvider.removeDataPoint(dataPoint);
  };

  changeTruckArr = (data) => {
    let currentList = [...this.truckArr];
    currentList.forEach((single, index) => {
      if (single.id == data.assetId) {
        const optData = {
          created: data.lastMessage.created,
          speed: data.lastMessage.gPRMC.speed,
        };
        const dataPoint = {
          id: data.assetId,
          lat: data.lastMessage.gPRMC.latitude,
          lng: data.lastMessage.gPRMC.longitude,
          optData: optData,
        };

        currentList[index] = dataPoint;
        this.truckArr = currentList;
      }

      this.mapSetting();
    });
  };

  mapSetting = () => {
    var dataPoints = [];
    this.truckArr.forEach((single) => {
      dataPoints.push(
        new window.H.clustering.DataPoint(
          single.lat,
          single.lng,
          null,
          single.optData
        )
      );
    });

    this.clusterAction(dataPoints);
  };

  setTruckPoints = async (setBounds) => {
    let newResponse = this.setResponseData(this.props.realTimeData);
    this.createDataPoints(newResponse);
    var dataPoints = [];

    if (setBounds) {
      if (this.truckArr.length > 1) {
        let lineString = new window.H.geo.LineString();
        let polyline;
        this.truckArr.forEach((point) => {
          lineString.pushLatLngAlt(point.lat, point.lng);
        });

        polyline = new window.H.map.Polyline(lineString, {
          style: {
            lineWidth: 3,
            strokeColor: "rgba(239, 93, 231, 0.8)",
          },
        });

        // And zoom to its bounding rectangle
        window.map.getViewModel().setLookAtData({
          bounds: polyline.getBoundingBox(),
        });
      } else if (this.truckArr.length === 1) {
        window.map.setCenter({
          lat: this.truckArr[0].lat,
          lng: this.truckArr[0].lng,
        });
      }

      // If only a single truck, zoom to show it
      if (this.truckArr.length === 1) {
        let userZoom = window.map.getZoom();
        if (userZoom === 0) {
          window.map.setZoom(14);
        } else {
          window.map.setZoom(window.map.getZoom());
        }
      }

      if (Object.keys(this.bubbleObj).length > 0) {
        if (this.bubbleObj.getState() !== "closed") {
          var data = this.truckArr.slice(-1)[0];
          if (data) {
            let newPosition = {
              lat: data.lat,
              lng: data.lng,
            };
            this.bubbleObj.setPosition(newPosition);
            this.bubbleObj.setContent(
              await this.getBubbleContent(data.optData)
            );
          }
        }
      }
    }

    this.truckArr.forEach((single) => {
      dataPoints.push(
        new window.H.clustering.DataPoint(
          single.lat,
          single.lng,
          null,
          single.optData
        )
      );
    });
    this.dataPoints = dataPoints;

    this.clusterAction(dataPoints);
  };

  setResponseData = (data) => {
    let newData = [];
    data &&
      data.length > 0 &&
      data.forEach((datum) => {
        if (datum.lastMessage != null) {
          datum.lastMessage.name = datum.assetName;
          datum.lastMessage.powerCut = datum.lastPowerCut || "";
          datum.lastMessage.duress = datum.lastDuress || "";
          datum.lastMessage.lastStatusChange = datum.lastStatusChange || "";
          datum.lastMessage.friendlyName = datum.friendlyName || "";

          newData.push(datum.lastMessage);
        }
      });

    return newData;
  };

  handleNullCheck = (value, index) => {
    if (
      this.props.realTimeData[index].message &&
      this.props.realTimeData[index].message.gPRMC
    ) {
      let thing = this.props.realTimeData[index].message.gPRMC[value];
      return thing;
    } else {
      return null;
    }
  };

  handleFridge = (tempA, tempB) => {
    if (tempA == 1) return "On";
    return "Off";
  };

  createDataPoints = (data) => {
    this.truckArr = [];

    data.forEach((datum) => {
      if (datum.gPRMC) {
        const optData = {
          assetId: datum.assetID,
          created: datum.created,
          lat: datum.gPRMC.latitude,
          lng: datum.gPRMC.longitude,
          address: datum.location,
          speed: datum.gPRMC.speed,
          odometer: datum.odometer,
          name: datum.name,
          tempA: datum.sensorAValue || "",
          tempB: datum.sensorBValue || "",
          fridge: this.handleFridge(datum.iO1, datum.sensorBValue),
          gprs: datum.gprsOnline,
          heading: datum.gPRMC.heading,
          parking: datum.iO3,
          trip: datum.tripCount,
          duress: datum.duress ? utcToReport24(datum.duress.created) : "",
          volt: datum.deviceVolts,
          // gprs: data.iO1,
          friendlyName: datum.friendlyName || "",
          satelite: datum.satellites,
          lastUpdated: datum.received,
          lastDuress: datum.duress || "",
          lastPowerCut: datum.powerCut || "",
          lastStatusChange: datum.lastStatusChange || "",
        };
        const dataPoint = {
          id: datum.assetID,
          lat: datum.gPRMC.latitude,
          lng: datum.gPRMC.longitude,
          optData: optData,
        };
        this.truckArr.push(dataPoint);
      }
    });
  };

  getTruckIcon = (name, heading) => {
    // Determine if we need to flip the truck icon vertically
    var flipTransform =
      heading >= 0 && heading <= 180 ? "scale(1, -1) translate(0, -48)" : "";

    var svgTruck = `<svg height="48" version="1.1" viewBox="0 0 960 48" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title">
          <g transform="rotate(${90 + heading} 24 24)">
            <path transform="${flipTransform}" fill="#6169FB" stroke="#6169FB" stroke-width="0.09375" opacity="1.00" d=" M 14.00 7.00 C 23.99 7.10 34.00 6.81 43.98 7.12 C 46.27 7.06 47.71 9.13 48.00 11.19 L 48.00 34.74 C 46.70 34.75 45.39 34.77 44.09 34.78 C 43.22 37.74 41.36 41.02 37.85 41.05 C 33.99 41.52 31.33 38.18 30.59 34.76 C 26.53 34.73 22.47 34.75 18.40 34.79 C 17.73 37.91 15.52 41.23 11.93 41.03 C 8.37 41.38 5.88 38.22 5.15 35.06 C 3.43 34.98 1.72 34.91 0.00 34.86 L 0.00 34.13 C 1.54 31.02 0.97 27.53 0.98 24.20 C 3.15 21.29 5.33 18.38 7.54 15.50 C 9.69 15.50 11.84 15.50 13.99 15.51 C 14.00 12.67 14.00 9.84 14.00 7.00 M 4.47 24.00 C 7.64 24.01 10.82 23.99 14.00 24.00 C 13.99 22.25 13.99 20.51 14.00 18.76 C 12.21 18.75 10.42 18.74 8.63 18.71 C 7.21 20.45 5.80 22.20 4.47 24.00 M 9.46 32.55 C 6.46 35.27 11.30 40.01 14.02 36.96 C 17.06 34.09 12.19 29.35 9.46 32.55 M 35.22 32.34 C 32.06 34.77 36.33 39.82 39.28 37.21 C 42.76 34.83 38.22 29.27 35.22 32.34 Z" />
          </g>
          <text x="56" y="34" fill="#6169FB" font-family="sans-serif" font-weight="500" font-size="2.25rem" id="text56">${name}</text>
      </svg>`;

    return new window.H.map.Icon(svgTruck, {
      size: { w: 480, h: 24 },
      anchor: { x: 12, y: 12 },
    });
  };

  getClusterIcon = (count) => {
    var radius = 12 + count / 4;
    var diameter = radius * 2;

    var fill = `#8387fb`;
    var color = "white";

    var x = radius;
    var y = radius * 1.4;

    var svgIcon = `<svg width="${diameter}" height="${diameter}" viewBox="0 0 ${diameter} ${diameter}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="${radius}" cy="${radius}" r="${radius}" fill="${fill}" />
        <text font-size="${radius}" fill="${color}" font-family="Verdana" text-anchor="middle" alignment-baseline="baseline" x="${x}" y="${y}">${count}</text>
      </svg>`;

    return new window.H.map.Icon(svgIcon, {
      size: { w: diameter, h: diameter },
      anchor: { x: radius, y: radius },
    });
  };

  clusterAction = (dataPoints) => {
    var unclusterZoomLevel = 14;

    var clusteredDataProvider = new window.H.clustering.Provider(dataPoints, {
      clusteringOptions: {
        eps: 50,
        minWeight: 2,
      },
    });

    var customTheme = {
      getClusterPresentation: (cluster) => {
        var clusterIcon = this.getClusterIcon(cluster.getWeight());

        var minZoom = cluster.getMinZoom();
        var maxZoom = cluster.getMaxZoom();

        if (maxZoom >= unclusterZoomLevel) maxZoom = unclusterZoomLevel - 1;

        // Create a marker for noise points:
        var clusterMarker = new window.H.map.Marker(cluster.getPosition(), {
          icon: clusterIcon,
          min: minZoom,
          max: maxZoom,
        });

        clusterMarker.setData(cluster);
        return clusterMarker;
      },
      getNoisePresentation: (noisePoint) => {
        var data = noisePoint.getData();
        var noiseIcon = this.getTruckIcon(data.name, data.heading);

        var minZoom = noisePoint.getMinZoom();
        if (minZoom > unclusterZoomLevel) minZoom = unclusterZoomLevel;

        // Create a marker for noise points:
        var noiseMarker = new window.H.map.Marker(noisePoint.getPosition(), {
          icon: noiseIcon,
          min: minZoom,
        });

        // Bind noise point data to the marker:
        noiseMarker.setData(noisePoint);
        return noiseMarker;
      },
    };

    clusteredDataProvider.setTheme(customTheme);

    clusteredDataProvider.addEventListener("tap", this.onMarkerClick);

    var layer = new window.H.map.layer.ObjectLayer(clusteredDataProvider);
    window.map.addLayer(layer);

    var oldLayer = this.clusterLayer;
    this.clusterLayer = layer;

    var hasRemoved = false;

    function removeOldLayer() {
      setTimeout(() => {
        if (hasRemoved) return;
        window.map.removeLayer(oldLayer);
        hasRemoved = true;
      }, 200);
    }

    // Defer removing the old points until we've rendered the new ones fully
    clusteredDataProvider.addEventListener("end", removeOldLayer);

    // With fallback if not yet removed, like if the window isn't focused
    setTimeout(() => {
      removeOldLayer();
    }, 14000);

    // Just a regular dispose() call causes horrible performance drops, so we're just gonna remove our events manually
    if (window.clusteredDataProvider) {
      window.clusteredDataProvider.removeEventListener(
        "tap",
        this.onMarkerClick
      );
      window.clusteredDataProvider.removeEventListener("end", removeOldLayer);
    }
    window.clusteredDataProvider = clusteredDataProvider;
  };

  onMarkerClick = (event) => {
    var position = event.target.getGeometry();
    var targetData = event.target.getData();

    // If we have a method for fetching a bounding box, we're a cluster
    if (targetData.getBoundingBox) {
      window.map.getViewModel().setLookAtData({
        bounds: targetData.getBoundingBox(),
      });
      return;
    }

    var assetData = targetData.data || targetData.getData();

    this.handleOpenBubble(position, assetData);
  };

  handleOpenBubble = (position, assetData) => {
    if (this.bubbleObj) {
      window.ui.removeBubble(this.bubbleObj);
    }

    window.map.setCenter(offsetMapLocation(window.map, position, { y: -100 }));

    let bubble = new window.H.ui.InfoBubble(position, {
      content: this.getBubbleContent(assetData),
    });

    window.ui.addBubble(bubble);
    this.bubbleObj = bubble;
  };

  getBubbleContent = (data) => {
    // Create a container div and render the React component into it
    const container = document.createElement("div");
    ReactDOM.render(
      <RealMapBubble
        data={data}
        history={this.props.history}
        setErrorMessageAction={this.props.setErrorMessageAction}
      />,
      container
    );
    return container;
  };

  render() {
    return (
      <React.Fragment>
        <div id="realMapContainer" tabIndex="0">
          <div id="mapScrollBlock">
            {!this.props.isFullScreen && (
              <div className="map-scroll-message">
                Hold Ctrl + scroll to zoom the map
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default RealMap;
